import styled from 'styled-components';
import { InPageAlert } from '@snsw-gel/react';

export const AlertNotification = styled(InPageAlert)`
    margin-bottom: 0;
    //margin-top: 1.8rem;
`;
